/** @jsx jsx */
import React, { useState, useEffect } from "react";
import { Card, Progress, Typography } from "antd";
import { jsx } from "@emotion/core";

import Button from "../../../components/button";
import useRedirect from "../../../helperHooks/useRedirect";
import useAPI from "../../../helperHooks/useAPI";
import profileService from "../../../services/profileService/ProfileService";

import { GetProfileDetailsResponse } from "../../../services/profileService/ProfileService.type";
import { GstinStatusPair } from "../../profile/ProfileConstants";
import { myInfoCardContents as CONSTANTS } from "./MyInfoCardConstants";
import { myInfoCardStyles } from "./MyInfoCardStyles";
import { color } from "../../../theme/Theme";

const { Text } = Typography;

interface HomePageCardProps {
  preventDataFetch: boolean;
}

const MyInfoCard: React.FC<HomePageCardProps> = ({
  preventDataFetch
}: HomePageCardProps) => {
  const redirect = useRedirect();
  const [percent, setPercent] = useState<number>(0);

  const { callAPI: getProfileDetails, loading: profileLoading } = useAPI(
    profileService.getProfileDetails
  );

  useEffect(() => {
    if (!preventDataFetch) {
      getProfileDetails({}, handleProfileDetailsSuccess);
    }
  }, [getProfileDetails, preventDataFetch]);

  const handleProfileDetailsSuccess = (
    response?: GetProfileDetailsResponse
  ) => {
    if (!response) {
      setPercent(0);
      return;
    }
    const responseValueList: Array<
      string | null | string[] | GstinStatusPair[]
    > = Object.values(response);
    if (!responseValueList.length) {
      setPercent(0);
      return;
    }
    const completedValueCount = responseValueList.filter(
      (responseValue: string | null | string[] | GstinStatusPair[]) =>
        responseValue && responseValue.length
    ).length;
    setPercent((completedValueCount * 100) / responseValueList.length);
  };

  const formatProgressPercent = () => (
    <Text className="active-percent-format">
      {percent.toPrecision(2) + "%"}
    </Text>
  );

  const handleGetStartedClick = () => {
    redirect(routes => routes.profile.new);
  };

  if (percent === 100) {
    // If Profile is completed, don't show the card.
    return null;
  }

  return (
    <Card bordered={false} loading={profileLoading} css={myInfoCardStyles}>
      <Text className="home-card-title">{CONSTANTS.labels.myInfoTitle}</Text>
      <Text className="d-block mt-4 profile-text">
        {CONSTANTS.labels.completeProfileInfo}
      </Text>
      <Progress
        className="mt-3 enabled-card"
        strokeWidth={26}
        strokeColor={color.primary}
        percent={percent}
        format={formatProgressPercent}
      />
      <Text className="d-block mt-4 profile-text">
        {CONSTANTS.labels.incompleteProfileNote}
      </Text>
      <Button
        type="default"
        size="small"
        containerDivClassName="justify-content-md-end mt-5"
        onClick={handleGetStartedClick}
      >
        {CONSTANTS.buttons.getStarted}
      </Button>
    </Card>
  );
};

export default MyInfoCard;
